import { Button } from "@mui/material";
import { googleAppRedirectUrl, googleAppUrl } from "../../constants/env-url";
import GoogleIcon from '../../assets/images/google.svg';

const SigninWithGoogleButton = () => {

  const loginWithGoogle = () => {
    window.open(googleAppUrl + '&redirect_uri=' + googleAppRedirectUrl, '_self');
  }

  return (
    <Button
      type="button"
      fullWidth
      variant="outlined"
      sx={{ mt: 2, mb: 2, display: 'flex', gap: 1, alignItems: 'center' }}
      style={{ textTransform: "none" }}
      onClick={loginWithGoogle}
    >
      <img src={GoogleIcon} alt="google" /> Sign in with Google
    </Button>
  );
}

export default SigninWithGoogleButton;
